import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dir", "width", "height", "fill"];
import React from 'react';
var circlePath = 'M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5zm0-1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18z';

var getPath = function getPath(dir) {
  if (dir === 'up') return "".concat(circlePath, "m4.02-6.674L12 10.976l-4.02 3.35a.75.75 0 0 1-.96-1.152l4.5-3.75a.75.75 0 0 1 .96 0l4.5 3.75a.75.75 0 0 1-.96 1.152z");
  if (dir === 'left') return "".concat(circlePath, "m2.076-13.02L10.726 12l3.35 4.02a.75.75 0 0 1-1.152.96l-3.75-4.5a.75.75 0 0 1 0-.96l3.75-4.5a.75.75 0 0 1 1.152.96z");
  if (dir === 'right') return "".concat(circlePath, "m-2.076-4.98l3.35-4.02-3.35-4.02a.75.75 0 1 1 1.152-.96l3.75 4.5a.75.75 0 0 1 0 .96l-3.75 4.5a.75.75 0 0 1-1.152-.96z");
  return "".concat(circlePath, "M7.98 9.674l4.02 3.35 4.02-3.35a.75.75 0 0 1 .96 1.152l-4.5 3.75a.75.75 0 0 1-.96 0l-4.5-3.75a.75.75 0 0 1 .96-1.152z");
};

var ChevronCircle = function ChevronCircle(_ref) {
  var _ref$dir = _ref.dir,
      dir = _ref$dir === void 0 ? 'down' : _ref$dir,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: getPath(dir)
  }));
};

ChevronCircle.displayName = 'ChevronCircle';
export default ChevronCircle;